import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { Rating } from './models/rating-item.model';

@Injectable({
  providedIn: 'root',
})
export class ReviewFormService {
  constructor(private _translateService: TranslateService) {}

  /**
   * Will be used by Business and Client Portal to build ratings
   */
  buildRatings(): List<Rating> {
    const ratings = [
      {
        id: 'communication_rating',
        category: this._translateService.instant(
          'REVIEW.RATING.COMMUNICATION_CATEGORY'
        ),
        question: this._translateService.instant(
          'REVIEW.RATING.COMMUNICATION_QUESTION'
        ),
      },
      {
        id: 'punctuality_rating',
        category: this._translateService.instant(
          'REVIEW.RATING.PUNCTUALITY_CATEGORY'
        ),
        question: this._translateService.instant(
          'REVIEW.RATING.PUNCTUALITY_QUESTION'
        ),
      },
      {
        id: 'quality_rating',
        category: this._translateService.instant(
          'REVIEW.RATING.QUALITY_CATEGORY'
        ),
        question: this._translateService.instant(
          'REVIEW.RATING.QUALITY_QUESTION'
        ),
      },
      {
        id: 'value_rating',
        category: this._translateService.instant(
          'REVIEW.RATING.VALUE_CATEGORY'
        ),
        question: this._translateService.instant(
          'REVIEW.RATING.VALUE_QUESTION'
        ),
      },
      {
        id: 'professionalism_rating',
        category: this._translateService.instant(
          'REVIEW.RATING.PROFESSIONALISM_CATEGORY'
        ),
        question: this._translateService.instant(
          'REVIEW.RATING.PROFESSIONALISM_QUESTION'
        ),
      },
    ];

    return List(ratings.map((rating) => new Rating(rating)));
  }
}
